<!-- Advanced centrale Modal-->
<template>
    <b-modal
      v-if="cu != null"
      :visible="visible" 
      @hidden="hide" 
      @change="change"
      @show="(cu.cu_type == 'logicafm') ? loadCuFlags() : loadSicuroCuFlags()"
      @ok="saveConfiguration"
      ok-only
      scrollable
      ref="modal"
      id="modal-advanced-cu"
      no-close-on-backdrop
      :title="$t('advanced_cu_modal.title', {tipo: cu.cu_type.toUpperCase(), id: cu.cu_id})"
      :hide-footer="!setting_changed"
      :ok-title="setting_changed?$t('advanced_cu_modal.modify_settings'):$t('close')"
    >

      <b-container fluid>
        <b-row>
          <b-col v-if="cu.cu_product_image" cols="4" class="my-auto text-center">
            <img  :src="pathDeviceImages  + cu.cu_product_image" style="height:60px; width:auto;" />
          </b-col>
          <b-col v-else cols="4" class="my-auto text-center">
              <img  v-if="cu.cu_type=='logicafm'" :src="'/img/logicafmsd/centrale.png'" style="height:60px; width:auto;" />
              <img  v-if="cu.cu_type=='logica'" :src="'/img/logica/centrale.png'" style="height:60px; width:auto;" />
              <img  v-if="cu.cu_type=='cablecom'" :src="'/img/cablecom/centrale.png'" style="height:60px; width:auto;" />
              <img  v-if="cu.cu_type == 'sicuro'" :src="pathDeviceImages + 'cu_sicuro.jpg'" style="height:60px; width:auto;" />
          </b-col>
          <b-col cols="8">
              <b-row>
                  <b-col cols="6">
                      <b-row><b-col cols="12">{{$t("details_cu_modal.cu_type")}}</b-col></b-row>
                      <b-row><b-col cols="12"><strong>{{cu.cu_type}}</strong></b-col></b-row>
                  </b-col>
                  <b-col cols="6">
                      <b-row><b-col cols="12">{{$t("details_cu_modal.cu_id")}}</b-col></b-row>
                      <b-row><b-col cols="12"><strong>{{cu.cu_id}}</strong></b-col></b-row>
                  </b-col>
              </b-row>
              <b-row class="mt-2">
                  <b-col cols="12">
                      <b-row><b-col cols="12">{{$t("details_cu_modal.cu_descrizione")}}</b-col></b-row>
                      <b-row>
                          <b-col cols="10"><strong>{{cu.cu_desc}}</strong></b-col>                          
                      </b-row>
                  </b-col>
              </b-row>
          </b-col>
        </b-row>

        <b-tabs v-if="cu.cu_type == 'logicafm'" v-model="tabIndex" class="PlanimetrieTabs typo-label mt-4" >
            
            <!-- Info GSM State -->
            <b-tab :title="$t('advanced_cu_modal.tab_gsm')" id="tab_advanced" lazy>
              <div class="typo-data">
                <b-row><b-col cols="8" offset-sm="1">{{$t("advanced_cu_modal.GSM_CONNECTED")}} :</b-col><b-col cols="3">{{cu.GSM_state.GSM_CONNECTED}}</b-col></b-row>
                <b-row><b-col cols="8" offset-sm="1">{{$t("advanced_cu_modal.GSM_FREE_1")}} :</b-col><b-col cols="3">{{cu.GSM_state.GSM_FREE_1}}</b-col></b-row>
                <b-row><b-col cols="8" offset-sm="1">{{$t("advanced_cu_modal.GSM_INIT_ON")}} :</b-col><b-col cols="3">{{cu.GSM_state.GSM_INIT_ON}}</b-col></b-row>
                <b-row><b-col cols="8" offset-sm="1">{{$t("advanced_cu_modal.GSM_LTE_HOOKED_SERVER")}} :</b-col><b-col cols="3">{{cu.GSM_state.GSM_LTE_HOOKED_SERVER}}</b-col></b-row>
                <b-row><b-col cols="8" offset-sm="1">{{$t("advanced_cu_modal.GSM_ON")}} :</b-col><b-col cols="3">{{cu.GSM_state.GSM_ON}}</b-col></b-row>
                <b-row><b-col cols="8" offset-sm="1">{{$t("advanced_cu_modal.GSM_PDP_CONTEXT_ACTIVATED")}} :</b-col><b-col cols="3">{{cu.GSM_state.GSM_PDP_CONTEXT_ACTIVATED}}</b-col></b-row>
                <b-row><b-col cols="8" offset-sm="1">{{$t("advanced_cu_modal.GSM_REGISTERED")}} :</b-col><b-col cols="3">{{cu.GSM_state.GSM_REGISTERED}}</b-col></b-row>
                <b-row><b-col cols="8" offset-sm="1">{{$t("advanced_cu_modal.GSM_REGISTERED_ROAMING")}} :</b-col><b-col cols="3">{{cu.GSM_state.GSM_REGISTERED_ROAMING}}</b-col></b-row>
                <b-row><b-col cols="8" offset-sm="1">{{$t("advanced_cu_modal.GSM_SOCKET_SERVICE_ACTIVATED")}} :</b-col><b-col cols="3">{{cu.GSM_state.GSM_SOCKET_SERVICE_ACTIVATED}}</b-col></b-row>              
              </div>
            </b-tab>
            
            <!-- Info Advanced Cu Flags -->
            <b-tab :title="$t('advanced_cu_modal.tab_advanced')" lazy>
              <div class="typo-data">

              <b-form-checkbox-group
                v-model="cu_flags_selected"
                :options="cu_flags_options"
                switches
                stacked
              ></b-form-checkbox-group>
              </div>
            </b-tab>

            <!-- Plant code -->
            <b-tab title="Plant code" lazy>
            
              <div class="typo-data">
                  <label for="select_plant_code" class="typo-label mb-2">{{$t("config_cu_modal.plant_code")}}
                  </label>
                  <b-form-select v-model="selected_plant_code" >
                    <option v-for="t in maxPlantCode" :value="t" :key="t">
                    {{ t }}
                    </option>
                  </b-form-select>
              </div>
            </b-tab>
        </b-tabs>

        <b-tabs v-else class="PlanimetrieTabs typo-label mt-4" align="center">

          <!-- Info Advanced Cu Flags -->
          <b-tab :title="$t('advanced_cu_modal.tab_advanced')" lazy>
            <b-form-group :label="$t('advanced_cu_modal.setting_list') + ':'" v-slot="{ ariaDescribedby }">
              <div class="typo-data">
                <b-form-checkbox-group
                  v-model="cu_flags_selected"
                  :options="cu_flags_options"
                  switches
                  stacked>
                </b-form-checkbox-group>
              </div>
            </b-form-group>
          </b-tab>
        </b-tabs>

      </b-container>    

    </b-modal>
</template>

<script>
// import Vue from 'vue'
// import { mapState } from "vuex";

export default {
  name: "AdvancedCentralUnit",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    cu: {
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    sendAction: null,
  },
  data() {
    return {
      cuSerial: "",
      cuType: "",
      cuDesc:"",
      tabIndex: 0,
      footer_hide: false,
      plantUnits: this.$store.state.plantUnits,
      cu_flags_selected: [], 
      cu_flags_options: [],
      cu_flags_setted:[],
      maxPlantCode:92,
      selected_plant_code:null,
      pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,   
    };
  },
  computed: { 
    setting_changed()
    {
      console.log("setting_changed, tabIndex:", this.tabIndex);
      if((this.tabIndex==1 && this.cu_flags_setted!=null && this.cu_flags_selected!=null && this.cu_flags_setted!=this.cu_flags_selected) || (this.tabIndex==2 && this.cu.plant_code!=this.selected_plant_code)) return true
      return false
    }
  },
  methods: {
    //load sicuro cu flags
    loadSicuroCuFlags() {
      //mantengo per sfruttare il tab-1 della logica fm 
      this.tabIndex=1;

      //clear options and selected cu flags
      //if cu_flags="ON" push also in selected 
      this.cu_flags_options=[];
      this.cu_flags_selected=[];
      this.cu_flags_setted=[];

      //set actual plant code
      this.selected_plant_code=this.cu.plant_code;

      //create cu_flags array and push selected
      this.cu_flags_options.push({text:this.$t("advanced_cu_modal.ALL_ON_TEST"),value:"ALL_ON_TEST"});
      if(this.cu.cu_flags.ALL_ON_TEST=="ON") this.cu_flags_selected.push("ALL_ON_TEST");

      this.cu_flags_options.push({text:this.$t("advanced_cu_modal.MODBUS_MODE"),value:"MODBUS_MODE"});
      if(this.cu.cu_flags.MODBUS_MODE=="ON") this.cu_flags_selected.push("MODBUS_MODE");

      this.cu_flags_options.push({text:this.$t("advanced_cu_modal.UNBLOCK_TEST"),value:"UNBLOCK_TEST"});
      if(this.cu.cu_flags.UNBLOCK_TEST=="ON") this.cu_flags_selected.push("UNBLOCK_TEST");

      if (this.cu.cu_system == "230") {
        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.DC_PHASE_ON_UV"),value:"DC_PHASE_ON_UV"});
        if(this.cu.cu_flags.DC_PHASE_ON_UV=="ON") this.cu_flags_selected.push("DC_PHASE_ON_UV");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.CHARGER_TEMPERATURE_COMPENSATION"),value:"CHARGER_TEMPERATURE_COMPENSATION"});
        if(this.cu.cu_flags.CHARGER_TEMPERATURE_COMPENSATION=="ON") this.cu_flags_selected.push("CHARGER_TEMPERATURE_COMPENSATION");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.PROPAGATE_KSK"),value:"PROPAGATE_KSK"});
        if(this.cu.cu_flags.PROPAGATE_KSK=="ON") this.cu_flags_selected.push("PROPAGATE_KSK");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.REFRESH_LUMINAIRE_PROGRAMMING"),value:"REFRESH_LUMINAIRE_PROGRAMMING"});
        if(this.cu.cu_flags.MODBUS_MODE=="ON") this.cu_flags_selected.push("REFRESH_LUMINAIRE_PROGRAMMING");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.RESET_TIMER_STAIRWAY_PB"),value:"RESET_TIMER_STAIRWAY_PB"});
        if(this.cu.cu_flags.MODBUS_MODE=="ON") this.cu_flags_selected.push("RESET_TIMER_STAIRWAY_PB");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.CRITICAL_CIRCUIT_IN_DC"),value:"CRITICAL_CIRCUIT_IN_DC"});
        if(this.cu.cu_flags.CRITICAL_CIRCUIT_IN_DC=="ON") this.cu_flags_selected.push("CRITICAL_CIRCUIT_IN_DC");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.DISABLE_UV_ON_LSSA_BUS_ERROR"),value:"DISABLE_UV_ON_LSSA_BUS_ERROR"});
        if(this.cu.cu_flags.DISABLE_UV_ON_LSSA_BUS_ERROR=="ON") this.cu_flags_selected.push("DISABLE_UV_ON_LSSA_BUS_ERROR");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.FIRE_DISCONNECTION"),value:"FIRE_DISCONNECTION"});
        if(this.cu.cu_flags.FIRE_DISCONNECTION=="ON") this.cu_flags_selected.push("FIRE_DISCONNECTION");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.LUMINAIRE_PROGRAMMING_IN_DC"),value:"LUMINAIRE_PROGRAMMING_IN_DC"});
        if(this.cu.cu_flags.LUMINAIRE_PROGRAMMING_IN_DC=="ON") this.cu_flags_selected.push("LUMINAIRE_PROGRAMMING_IN_DC");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.SD_IN_AC_DC_MODE"),value:"SD_IN_AC_DC_MODE"});
        if(this.cu.cu_flags.SD_IN_AC_DC_MODE=="ON") this.cu_flags_selected.push("SD_IN_AC_DC_MODE");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.SEARCH_LUM_OTHER_LINES_OFF"),value:"SEARCH_LUM_OTHER_LINES_OFF"});
        if(this.cu.cu_flags.SEARCH_LUM_OTHER_LINES_OFF=="ON") this.cu_flags_selected.push("SEARCH_LUM_OTHER_LINES_OFF");

        this.cu_flags_options.push({text:this.$t("advanced_cu_modal.INSULATION_TEST_AUTOMATIC_ACTIVATED"),value:"INSULATION_TEST_AUTOMATIC_ACTIVATED"});
        if(this.cu.cu_flags.INSULATION_TEST_AUTOMATIC_ACTIVATED=="ON") this.cu_flags_selected.push("INSULATION_TEST_AUTOMATIC_ACTIVATED");      
      }
      //fill setted flags array with initial selected
      this.cu_flags_setted=this.cu_flags_selected;
    },

    loadCuFlags(){
     //set default tab 
     this.tabIndex=0;

     //clear options and selected cu flags
     //if cu_flags="ON" push also in selected 
     this.cu_flags_options=[];
     this.cu_flags_selected=[];
     this.cu_flags_setted=[];
     
     //set actual plant code
     this.selected_plant_code=this.cu.plant_code;

     //create cu_flags array and push selected
     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.ACTIVATE_LAST_SCENE_AT_RESET"),value:"ACTIVATE_LAST_SCENE_AT_RESET"});
     if(this.cu.cu_flags.ACTIVATE_LAST_SCENE_AT_RESET=="ON") this.cu_flags_selected.push("ACTIVATE_LAST_SCENE_AT_RESET");
     
     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.ALBA_E_TRAMONTO_NON_ATTIVI_SE_DATA_ESATTA"),value:"ALBA_E_TRAMONTO_NON_ATTIVI_SE_DATA_ESATTA"});
     if(this.cu.cu_flags.ALBA_E_TRAMONTO_NON_ATTIVI_SE_DATA_ESATTA=="ON") this.cu_flags_selected.push("ALBA_E_TRAMONTO_NON_ATTIVI_SE_DATA_ESATTA");
    
     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.ASSENZA_RETE_LOGICA_FM_NO_CAUSE_ERR"),value:"ASSENZA_RETE_LOGICA_FM_NO_CAUSE_ERR"});
     if(this.cu.cu_flags.ALBA_E_TRAMONTO_NON_ATTIVI_SE_DATA_ESATTA=="ON") this.cu_flags_selected.push("ALBA_E_TRAMONTO_NON_ATTIVI_SE_DATA_ESATTA");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.ATTIVITA_PENDING_DISABLED"),value:"ATTIVITA_PENDING_DISABLED"});
     if(this.cu.cu_flags.ASSENZA_RETE_LOGICA_FM_NO_CAUSE_ERR=="ON") this.cu_flags_selected.push("ASSENZA_RETE_LOGICA_FM_NO_CAUSE_ERR");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.CALIBRAZIONE_NOTTURNA_ENABLED"),value:"CALIBRAZIONE_NOTTURNA_ENABLED"});
     if(this.cu.cu_flags.CALIBRAZIONE_NOTTURNA_ENABLED=="ON") this.cu_flags_selected.push("CALIBRAZIONE_NOTTURNA_ENABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.ENABLE_NEW_CREA_RETE_FOR_RETRY"),value:"ENABLE_NEW_CREA_RETE_FOR_RETRY"});
     if(this.cu.cu_flags.ENABLE_NEW_CREA_RETE_FOR_RETRY=="ON") this.cu_flags_selected.push("ENABLE_NEW_CREA_RETE_FOR_RETRY");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.ETHO_CLIENT_INTERNET"),value:"ETHO_CLIENT_INTERNET"});
     if(this.cu.cu_flags.ETHO_CLIENT_INTERNET=="ON") this.cu_flags_selected.push("ETHO_CLIENT_INTERNET");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.LOG_RADIO_DISABLED"),value:"LOG_RADIO_DISABLED"});
     if(this.cu.cu_flags.LOG_RADIO_DISABLED=="ON") this.cu_flags_selected.push("LOG_RADIO_DISABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.MANCANZA_RETE"),value:"MANCANZA_RETE"});
     if(this.cu.cu_flags.MANCANZA_RETE=="ON") this.cu_flags_selected.push("MANCANZA_RETE");
     
     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.NO_CHECK_STATE_IO_EXT_AT_RESET"),value:"NO_CHECK_STATE_IO_EXT_AT_RESET"});
     if(this.cu.cu_flags.NO_CHECK_STATE_IO_EXT_AT_RESET=="ON") this.cu_flags_selected.push("NO_CHECK_STATE_IO_EXT_AT_RESET");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.PASSWORD_CENLOG_ENABLED"),value:"PASSWORD_CENLOG_ENABLED"});
     if(this.cu.cu_flags.PASSWORD_CENLOG_ENABLED=="ON") this.cu_flags_selected.push("PASSWORD_CENLOG_ENABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.POLL_RADIO_DISABLED"),value:"POLL_RADIO_DISABLED"});
     if(this.cu.cu_flags.POLL_RADIO_DISABLED=="ON") this.cu_flags_selected.push("POLL_RADIO_DISABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.RETRY_RADIO_MSG_HIGH"),value:"RETRY_RADIO_MSG_HIGH"});
     if(this.cu.cu_flags.RETRY_RADIO_MSG_HIGH=="ON") this.cu_flags_selected.push("RETRY_RADIO_MSG_HIGH");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.RIBADIRE_EVENTI_ENABLED"),value:"RIBADIRE_EVENTI_ENABLED"});
     if(this.cu.cu_flags.RIBADIRE_EVENTI_ENABLED=="ON") this.cu_flags_selected.push("RIBADIRE_EVENTI_ENABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.SCENARI_DISPLAY_DISABLED"),value:"SCENARI_DISPLAY_DISABLED"});
     if(this.cu.cu_flags.SCENARI_DISPLAY_DISABLED=="ON") this.cu_flags_selected.push("SCENARI_DISPLAY_DISABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.SEARCH_ALT_FATHER_DISABLED"),value:"SEARCH_ALT_FATHER_DISABLED"});
     if(this.cu.cu_flags.SEARCH_ALT_FATHER_DISABLED=="ON") this.cu_flags_selected.push("SEARCH_ALT_FATHER_DISABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.SEARCH_ORPHAN_DISABLED"),value:"SEARCH_ORPHAN_DISABLED"});
     if(this.cu.cu_flags.SEARCH_ORPHAN_DISABLED=="ON") this.cu_flags_selected.push("SEARCH_ORPHAN_DISABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.SIGN_COMM_ERR_DISABLED"),value:"SIGN_COMM_ERR_DISABLED"});
     if(this.cu.cu_flags.SIGN_COMM_ERR_DISABLED=="ON") this.cu_flags_selected.push("SIGN_COMM_ERR_DISABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.SMS_ALARMS_ENABLED"),value:"SMS_ALARMS_ENABLED"});
     if(this.cu.cu_flags.SMS_ALARMS_ENABLED=="ON") this.cu_flags_selected.push("SMS_ALARMS_ENABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.TEST_AUT_DIFFERITO"),value:"TEST_AUT_DIFFERITO"});
     if(this.cu.cu_flags.TEST_AUT_DIFFERITO=="ON") this.cu_flags_selected.push("TEST_AUT_DIFFERITO");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.USE_ALT_FATHER_DISABLED"),value:"USE_ALT_FATHER_DISABLED"});
     if(this.cu.cu_flags.USE_ALT_FATHER_DISABLED=="ON") this.cu_flags_selected.push("USE_ALT_FATHER_DISABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.VIS_ENERGY_FROM_DOWN"),value:"VIS_ENERGY_FROM_DOWN"});
     if(this.cu.cu_flags.VIS_ENERGY_FROM_DOWN=="ON") this.cu_flags_selected.push("VIS_ENERGY_FROM_DOWN");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.VIS_TACCHE_GSM"),value:"VIS_TACCHE_GSM"});
     if(this.cu.cu_flags.VIS_TACCHE_GSM=="ON") this.cu_flags_selected.push("VIS_TACCHE_GSM");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.WATCHDOG_DISABLED"),value:"WATCHDOG_DISABLED"});
     if(this.cu.cu_flags.WATCHDOG_DISABLED=="ON") this.cu_flags_selected.push("WATCHDOG_DISABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.WIFI_ENABLED"),value:"WIFI_ENABLED"});
     if(this.cu.cu_flags.WIFI_ENABLED=="ON") this.cu_flags_selected.push("WIFI_ENABLED");

     this.cu_flags_options.push({text:this.$t("advanced_cu_modal.WIFI_STA_MODE"),value:"WIFI_STA_MODE"});
     if(this.cu.cu_flags.WIFI_STA_MODE=="ON") this.cu_flags_selected.push("WIFI_STA_MODE");
     
     //fill setted flags array with initial selected
     this.cu_flags_setted=this.cu_flags_selected;

    },
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    saveConfiguration() {
      var params = {};
      if(this.tabIndex==2)
      {       
        params.command = "setPlantCode";
        params.plantCode = this.selected_plant_code;
        console.log("Set plant code:", params);
        this.sendAction(params);
      }

      if(this.tabIndex==1)
      {
        params.command = "setCuFlags";
        params.cuFlags = this.cu_flags_selected;
        console.log("Set Cu flags", params);
        this.sendAction(params);
      }

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    },
    handleRemove(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
     }
  }
};
</script>

<style lang="scss">
  #tab_advanced .nav-tabs{
    font-weight: bold;
  }
  .typo-data{
    font-weight:400;
    font-family: Roboto;
    font-size: 13px;
  }
  // .card-border-azzurro .card-body {
  //   border: 2px solid #007BFF; /* Azzurro Bootstrap */
  //   border-radius: 0.25rem; /* opzionale, per angoli arrotondati */
  //   padding: 1rem;
  // }
  // .no-header-border .card-header {
  //   border: none;
  // }
</style>